import React from 'react';
import ScreenListing from '../components/ScreenListing';

export default (props) => {
  const { data } = props;

  return (
    <>
      <ScreenListing
        {...props}
        datalist={data?.promotion_screen_list}
        buttonType={"promotion_screen"}
      />
    </>
  )
}